<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div>
          <el-button size="small" type="primary" :disabled="!flag" @click="addToCart">批量锁定…</el-button>
        </div>

        <div class="searchBox">
          <div style="float: left">
            <el-select v-model="f_subjectId" slot="prepend" placeholder="请选择">
              <el-option v-for="item in subjects" :key="item.subjectId" :label="item.subjectName" :value="item.subjectId"> </el-option>
            </el-select>
          </div>
          <div style="float: left; width: 300px">
            <el-input placeholder="稿件标题" v-model="f_title" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
            </el-input>
          </div>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" style="width: 100%" @select-all="selAll" @selection-change="selChange">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"></el-table-column>

            <el-table-column prop="authorName" label="作者" width="80"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="createTime" label="编辑审稿完成时间">
              <template slot-scope="scope">
                {{ scope.row.editorTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="pt" label="操作" fixed="right" width="110">
              <template slot-scope="scope">
                <el-button type="primary" @click="lockAndAudit(scope.row.id)">锁定并审稿</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="curPage" @current-change="pageChange"> </el-pagination>
      </div>
    </div>

    <el-drawer title="稿件审稿" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1" style="padding: 0 20px 20px 20px">
          <ArticleProcess ref="ArticleProcess" role="EXPERT" :articleId="curArticleId" @examineReject="examineReject" @rejectSuccess="rejectSuccess" @submitSuccess="rejectSuccess"></ArticleProcess>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ArticleProcess from "@/components/ArticleProcess.vue"
import expertApi from "@/api/expert"
/**
 * 待评审页面
 * 步骤,100退稿。
 * 10作者提交稿件，
 * 20待编辑首次审稿，21作者一次改稿,22编辑第二次审稿。
 * 30交审稿费。
 * 40专家首次审稿，41作者二次改稿,42专家第二次审稿。
 *
 * 50编辑查重，51作者三次改稿，52编辑二次查重。
 * 60登记版面费，出录用通知；
 * 70交版面费。
 * 80填写发票信息。
 * 90完成。
 */
export default {
  components: { PageHeader, ArticleProcess },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "稿件池" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",
      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
      flag: false,
      drawer: false,
      curArticleId: 0,
    }
  },

  mounted() {
    this.loadSubjects()
  },

  methods: {
    loadSubjects() {
      expertApi.mySubjectList().then((res) => {
        this.subjects = res.data
        this.subjects.unshift({
          subjectId: -1,
          subjectName: "所有",
        })

        this.loadData()
      })
    },

    loadData() {
      expertApi.articleListGJC(this.f_subjectId, this.f_title, "createTime", "desc", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
        this.flag = false
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    addToCart() {
      this.$confirm("确定锁定这些稿件，锁定后稿件只能由您进行审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let selRows = this.$refs.tableData.selection
        let articleIds = []
        selRows.forEach((element) => {
          console.log(element)
          articleIds.push(element.id)
        })

        expertApi.addArticlesToCart(articleIds).then((res) => {
          if (res.code == 0) {
            this.$notify({
              title: "成功",
              message: res.msg,
              type: "success",
            })
            this.getStat()
            this.loadData()
          } else {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            })
          }
        })
      })
    },

    lockAndAudit(articleId) {
      this.curArticleId = articleId
      expertApi.addArticleToCart(articleId).then((res) => {
        if (res.code == 0) {
          this.$notify({ title: "成功", message: res.msg, type: "success" })
          this.openDrawer()
          this.getStat()
          setTimeout(() => {
            this.loadData()
          }, 1500)
        } else {
          this.$message({ message: res.msg, type: "warning" })
        }
      })
    },

    openDrawer() {
      this.drawer = true
    },

    examineReject() {
      this.drawer = false
      this.loadData()
    },

    rejectSuccess() {
      this.drawer = false
      this.loadData()
    },
  },
}
</script>

<style scoped>
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}
.sn {
  font-family: "Courier New", Courier, monospace;
}
</style>
